import React, { Component } from "react";
import TableHead from "./tableHead/tableHead";
import TableBody from "./tableBody/tableBody";
import { Cookies } from "react-cookie";
import ReactExport from "react-export-excel";
import "./resultsTable.css";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class ResultsTable extends Component {
    state = {
        results: null,
        name: null
    };

    retunExcelFile = (userAnswers, testName) => {
        let excelFile = null;
        if (testName === "Test1") {
            let data = userAnswers;
            let signalProbability = 0;
            for (let i = 0; i < data.length; i++) {
                if (data[i].correct) {
                    signalProbability++;
                }
            }
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.signalCorrect = elem.isUserAnswerCorrect ? 1 : 0;
                elem.signalProbability = parseInt(
                    Math.round((signalProbability / data.length) * 100)
                );
                elem.noise = elem.total - elem.correct;
                elem.signalText =
                    elem.correct >= 1 ? "სიგნალი არის" : "სიგნალი არ არის";
                elem.tureGuess = elem.correct >= 1 && elem.userAnswerBool == true ? 1 : 0;
                elem.falseAlarm = elem.correct === 0 && elem.userAnswerBool == true ? 1 : 0;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn
                            label="სიგნალის ალბათობა"
                            value="signalProbability"
                        />
                        <ExcelColumn
                            label="სიგნალის ინტენსივობა"
                            value="correct"
                        />
                        <ExcelColumn label="ხმაურის ინტესივობა" value="noise" />
                        <ExcelColumn
                            label="სიგნალის არსებობა"
                            value="signalText"
                        />
                        <ExcelColumn label="სისწორე" value="signalCorrect" />
                        <ExcelColumn label="სწორი ამოცნობა" value="tureGuess" />
                        <ExcelColumn label="ცრუ განგაში" value="falseAlarm" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if (testName === "Test2") {
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn
                            label="მსგავსების ტიპი"
                            value="similarityType"
                        />
                        <ExcelColumn label="სისწორე" value="correct" />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if (testName === "Test3") {
            console.log(userAnswers);
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
                let Congruent;
                if (
                    (elem.text === "ლურჯი" && elem.color === "#0000ff") ||
                    (elem.text === "მწვანე" && elem.color === "#009933") ||
                    (elem.text === "ყვითელი" && elem.color === "#ffff00") ||
                    (elem.text === "წითელი" && elem.color === "#ff0000")
                ) {
                    Congruent = "კონგრუენტული";
                } else {
                    if (
                        (elem.text === "ლურჯი" && elem.color !== "#0000ff") ||
                        (elem.text === "მწვანე" && elem.color !== "#009933") ||
                        (elem.text === "ყვითელი" && elem.color !== "#ffff00") ||
                        (elem.text === "წითელი" && elem.color !== "#ff0000")
                    ) {
                        Congruent = "არაკონგრუენტული";
                    } else {
                        if (
                            elem.text !== "ლურჯი" ||
                            elem.text !== "მწვანე" ||
                            elem.text !== "ყვითელი" ||
                            elem.text !== "წითელი"
                        ) {
                            Congruent = "ნეიტრალური";
                        }
                    }
                }

                elem.Congruent = Congruent;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn label="კონგრუენტულობა" value="Congruent" />
                        <ExcelColumn label="სისწორე" value="correct" />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if (testName === "Test4") {
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
                elem.symbols = `${elem.distractor} ${elem.aimStimul} ${elem.distractor}`;
                let distractorType = null;
                if (elem.distractor === elem.aimStimul) {
                    distractorType = "თავსებადი";
                } else {
                    if (
                        elem.distractor !== elem.aimStimul &&
                        (elem.distractor === "S" || elem.distractor === "H")
                    ) {
                        distractorType = "არათავსებადი";
                    } else {
                        distractorType = "ნეიტრალური";
                    }
                }
                elem.distractorType = distractorType;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn
                            label="სამიზნე სტიმული"
                            value="aimStimul"
                        />
                        <ExcelColumn
                            label="დისტრაქტორი სტიმული"
                            value="distractor"
                        />
                        <ExcelColumn label="სტიმულები" value="symbols" />
                        <ExcelColumn
                            label="დისტრაქტორი სტიმულის ტიპი"
                            value="distractorType"
                        />
                        <ExcelColumn label="დაშორება" value="margin" />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                        <ExcelColumn label="სისწორე" value="correct" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if (testName === "Test5") {
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn label="ბრუნვის კუთხე" value="degree" />
                        <ExcelColumn label="სტიმულის სახე" value="reverse" />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                        <ExcelColumn label="სისწორე" value="correct" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if (testName === "Test6") {
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
                elem.alterQuantity = elem.type === "type3" ? "4" : "2";
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn label="სტიმული" value="stimul" />
                        <ExcelColumn
                            label="ალტერნატივათა რაოდენობა"
                            value="alterQuantity"
                        />
                        <ExcelColumn
                            label="პასუხების სისწორე"
                            value="correct"
                        />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }

        if (testName === "Test7") {
            let data = userAnswers;
            data.map((elem, i) => {
                elem.number = i + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
            });
            excelFile = (
                <ExcelFile>
                    <ExcelSheet data={data} name="შედეგები">
                        <ExcelColumn label="ცდის ნომერი" value="number" />
                        <ExcelColumn label="ბრუნვის კუთხე" value="degree" />
                        <ExcelColumn label="სტიმულის სახე" value="reverse" />
                        <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                        <ExcelColumn label="სისწორე" value="correct" />
                    </ExcelSheet>
                </ExcelFile>
            );
        }
        if(testName === "Test9"){
            let data = userAnswers;
            data.map((elem, i)=>{
                let stimPosition = elem.sequence.toString().indexOf(elem.symbol.toString());
                elem.number = i +1;
                elem.sequenceSize = elem.sequence.toString().length;
                elem.realAnswerString = elem.realAnswer ? 'სტიმული არის': 'სტიმული არ არის';
                elem.stimPosition = stimPosition === -1 ? 0 : stimPosition + 1;
                elem.correct = elem.isUserAnswerCorrect ? 1 : 0;
            });
            excelFile = (
            <ExcelFile>
                <ExcelSheet data={data} name="შედეგები">
                    <ExcelColumn label="ცდის ნომერი" value="number" />
                    <ExcelColumn label="ციფრების მწკრისვის ზომა" value="sequenceSize" />
                    <ExcelColumn label="სტიმულის არსებობა" value="realAnswerString" />
                    <ExcelColumn label="სტიმულის პოზიცია" value="stimPosition" />
                    <ExcelColumn label="რეაქციის დრო" value="answerTime" />
                    <ExcelColumn label="სისწორე" value="correct" />
                </ExcelSheet>
            </ExcelFile>

            )
        }

        return excelFile;

    };

    componentDidMount() {
        let cookie = new Cookies();
        this.props.openInstuctions(true);
        let tableData = JSON.parse(localStorage.getItem("chartData"));
        console.log(tableData);
        const resultsForChart = tableData.results;
        let chartValues = {};
        let xAxis = [];
        let yAxis = [];
        resultsForChart.map((elem, i) => {
            xAxis.push(i + 1);
            yAxis.push(elem.answerTime);
        });
        chartValues.x = xAxis;
        chartValues.y = yAxis;
        this.setState({ chartValues });
    }

    returnTabelHead = name => {
        let tableHead = null;
        switch (name) {
            case "Test1":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "სიგნალის ალბათობა"
                    },
                    {
                        id: "2",
                        name: "სიგნალის ინტენსივობა"
                    },
                    {
                        id: "3",
                        name: "ხმაურის ინტესივობა"
                    },
                    {
                        id: "4",
                        name: "სიგნალის არსებობა"
                    },
                    {
                        id: "5",
                        name: "სისწორე"
                    },
                    {
                        id: "6",
                        name: "სწორი ამოცნობა"
                    },
                    {
                        id: "7",
                        name: "ცრუ განგაში"
                    }
                ];
                break;
            case "Test2":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "მსგავსების ტიპი"
                    },
                    {
                        id: "2",
                        name: "სისწორე"
                    },
                    {
                        id: "3",
                        name: "რეაქციის დრო"
                    }
                ];
                break;
            case "Test3":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "კონგრუენტულობა"
                    },
                    {
                        id: "2",
                        name: "სისწორე"
                    },
                    {
                        id: "3",
                        name: "რეაქციის დრო"
                    }
                ];
                break;
            case "Test4":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "სამიზნე სტიმული"
                    },
                    {
                        id: "2",
                        name: "დისტრაქტორი სტიმული"
                    },
                    {
                        id: "3",
                        name: "სტიმულები"
                    },
                    {
                        id: "4",
                        name: "დისტრაქტორი სტიმულის ტიპი"
                    },
                    {
                        id: "5",
                        name: "დაშორება"
                    },
                    {
                        id: "6",
                        name: "რეაქციის დრო"
                    },
                    {
                        id: "7",
                        name: "სისწორე"
                    }
                ];
                break;
            case "Test5":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "სიგნალის ალბათობა"
                    },
                    {
                        id: "2",
                        name: "სიგნალის არსებობა"
                    },
                    {
                        id: "3",
                        name: "სისწორე"
                    },
                    {
                        id: "4",
                        name: "სწორი ამოცნობა"
                    },
                    {
                        id: "5",
                        name: "ცრუ განგაში"
                    }
                ];
                break;
            case "Test6":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "სტიმული"
                    },
                    {
                        id: "2",
                        name: "ალტერნატივათა რაოდენობა"
                    },
                    {
                        id: "3",
                        name: "პასუხების სისწორე"
                    },
                    {
                        id: "4",
                        name: "რეაქციის დრო"
                    }
                ];
                break;
            case "Test7":
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "ბრუნვის კუთხე"
                    },
                    {
                        id: "2",
                        name: "სტიმულის სახე"
                    },
                    {
                        id: "3",
                        name: "რეაქციის დრო"
                    },
                    {
                        id: "4",
                        name: "სისწორე"
                    }
                ];
                break;
            case "Test8": 
                tableHead = [
                    {
                        id: "0",
                        name: "ცდის ნომერი"
                    },
                    {
                        id: "1",
                        name: "ბრუნვის კუთხე"
                    },
                    {
                        id: "2",
                        name: "სტიმულის სახე"
                    },
                    {
                        id: "3",
                        name: "რეაქციის დრო"
                    },
                    {
                        id: "4",
                        name: "სისწორე"
                    }
                ];
                break;
                case "Test9": 
                    tableHead = [
                        {
                            id: "0",
                            name: "ცდის ნომერი"
                        },
                        {
                            id: "1",
                            name: "ციფრების მწკრივის ზომა"
                        },
                        {
                            id: "2",
                            name: "სტიმულის არსებობა"
                        },
                        {
                            id: "3",
                            name: "სტიმულის პოზიცია"
                        },
                        {
                            id: "4",
                            name: "რეაქციის დრო"
                        },
                        {
                            id: "5",
                            name: "სისწორე"
                        }
                    ];
                break;                    
        }
        return tableHead;
    };

    render() {
        // let cookies = new Cookies();
        // let tableData = cookies.get('chartData');
        console.log(JSON.parse(localStorage.getItem("chartData")));
        let tableData = JSON.parse(localStorage.getItem("chartData"));
        let name = tableData.name;
        let results = tableData.results;
        let excelFile = this.retunExcelFile(results, name);
        const tableHead = this.returnTabelHead(name);
        return (
            <React.Fragment>
                <section className="results-table">
                    <table className="table table-bordered table-hover">
                        <TableHead tableHead={tableHead} />
                        <TableBody tableBody={results} name={name} />
                    </table>
                    {excelFile}
                </section>
            </React.Fragment>
        );
    }
}

export default ResultsTable;
